import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Setting } from '../../../models/models';
import {SettingService} from "../../../services/setting.service";
import {FormBuilder, Validators} from "@angular/forms";
import {NGXLogger} from "ngx-logger";

@Component({
  selector: 'app-setting-edit',
  templateUrl: './setting-edit.component.html',
  styleUrls: ['./setting-edit.component.scss']
})
export class SettingEditComponent implements OnInit {
  dialogTitle!: string;
  setting! : Setting;
  versions : number[] = [1];
  languages : string[] = ['EN'];

  settingsForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    value: [],
    description: [],
    language: ['', [Validators.required]],
    version: ['', [Validators.min(1), Validators.max(9999999999)]],
  });

  /**
   * Constructor
   * @param formBuilder Form builder instance
   * @param settingService Settings service instance.
   * @param dialogRef Dialog reference.
   * @param data Data passed into the dialog.
   * @param logger Logger instance.
   */
  constructor(
    private formBuilder : FormBuilder,
    private settingService : SettingService,
    public dialogRef: MatDialogRef<SettingEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {setting: Setting, title: string},
    private logger: NGXLogger) { }

  /**
   * Init
   */
  ngOnInit(): void {
    this.dialogTitle = this.data.title;
    if (this.data.setting != undefined) {
      this.setting = JSON.parse(JSON.stringify(this.data.setting));
    }

    this.settingService.getSettingVersions(0).then((versions) => {
        this.versions = versions;
      }
    );

    this.settingService.getSettingLanguages().then((languages) => {
        this.languages = languages;
      }
    );
  }

  /**
   * Called when the dialog is submitted.
   */
  onSubmit() {
    this.logger.debug("ProductEditComponent-onOk - Closing Product Edit, Product updates:" + JSON.stringify(this.setting));
    this.dialogRef.close(this.setting);
  }
}
